import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosteingangComponent } from './components/posteingang/posteingang.component';
import { NachrichtComponent } from './components/nachricht/nachricht.component';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';

const routes: Routes = [
    {path: RouteNames.BASE, component: PosteingangComponent},
    {path: RouteNames.SUB_PAGE, component: NachrichtComponent}
];


@NgModule({
    declarations: [
        PosteingangComponent,
        NachrichtComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ]
})
export class PosteingangModule {
}
